import { createFormControl } from "solid-forms-react";

// Note that these calls to createFormControl, outside of a component,
// will cause the following warning to be logged in dev mode:
// - "computations created outside a `createRoot` or `render` will never be disposed"
//
// This is ok, as we these controls exist for the lifetime of the app.
export const onlySearchSeenPostsControl = createFormControl(false);
